import React from 'react';
import ExperienceSection from '../components/Experience/ExperienceSection';

export default function Experiences() {
  return (
    <div className="min-h-screen bg-white pt-8">
      <ExperienceSection />
    </div>
  );
}